module.exports = __webpack_public_path__ + "images.420c06c.jpg";